export const formatPrice = (value) => {
  const num = parseFloat(value)
  if (Number.isNaN(num)) return '0.00'
  return num.toFixed(2)
}
